import { useEffect, useMemo, useState } from 'react'
import FactuurRij from '../onderdelen/FactuurRij'
import { FoutVak, Kop, Laden, Leeg, Ververs } from '../onderdelen/ui'
import { aantal } from '../lib/opmaak'
import { bakkenVan, laadWerk, useStaat, type Bakken } from '../lib/staat'

/* ===========================================================================
 *  To-do: wat er op JOUW naam staat
 *
 *  Bovenaan "Van mij": alleen facturen waar jij bij de stap staat die nu aan
 *  de beurt is (zie bakkenVan in lib/bakken.ts). Dat is ook het getal op de
 *  tegel. Van mij en Valideren samen zijn precies de To-do van TW10 Online
 *  (zicht.ts, wachtOpMij); Exact en Zonder naam zoals het overzicht daar
 *  voor wie alles ziet of boekt. Wat in dispuut staat, staat stil en dus in
 *  geen van die bakken, maar wel onder In dispuut (0240).
 *
 *  Komt het dashboard je hierheen sturen vanuit Verkoopfacturen
 *  (?soort=verkoop), dan opent de valideerstapel met alleen verkoop: een
 *  verkoopfactuur kent geen handtekening op naam (0192).
 * =========================================================================== */

type Bak = keyof Bakken

const NAAM: Record<Bak, string> = { mij: 'Van mij', valideren: 'Valideren', exact: 'Exact', zonderNaam: 'Zonder naam', dispuut: 'In dispuut' }

const LEEG: Record<Bak, string> = {
  mij: 'Er ligt niets op jouw naam. Dat is geen foutmelding.',
  valideren: 'Er hoeft niets gevalideerd te worden.',
  exact: 'Er staat niets klaar voor Exact, en Exact weigerde niets.',
  zonderNaam: 'Elke factuur heeft iemand bij de volgende stap.',
  dispuut: 'Er staat niets in dispuut.',
}

export default function Todo() {
  const ik = useStaat((s) => s.ik)
  const werk = useStaat((s) => s.werk)
  const laden = useStaat((s) => s.werkLaden)
  const fout = useStaat((s) => s.werkFout)

  const zoek = new URLSearchParams(location.search)
  const alleenVerkoop = zoek.get('soort') === 'verkoop'
  const [bak, setBak] = useState<Bak>(() => {
    const b = zoek.get('bak')
    if (b === 'valideren' || b === 'exact' || b === 'zonderNaam' || b === 'dispuut') return b
    return alleenVerkoop ? 'valideren' : 'mij'
  })
  const [verkoopFilter, setVerkoopFilter] = useState(alleenVerkoop)

  useEffect(() => { void laadWerk() }, [])

  const bakken = useMemo(() => (ik && werk ? bakkenVan(werk.bonnen, ik) : null), [ik, werk])
  const lijst = useMemo(() => {
    const rij = bakken?.[bak] ?? []
    return verkoopFilter ? rij.filter((b) => b.richting === 'verkoop') : rij
  }, [bakken, bak, verkoopFilter])

  /* "Van mij" altijd; de rest alleen als er iets in zit, en Valideren alleen
     voor wie mag valideren (anders is die bak al leeg). */
  const tabs: Bak[] = (['mij', 'valideren', 'exact', 'zonderNaam', 'dispuut'] as Bak[])
    .filter((b) => b === 'mij' || b === bak || (bakken?.[b].length ?? 0) > 0)

  return (
    <div className="scherm">
      <Kop
        terugNaar="/" terugLabel="Dashboard" titel="To-do"
        ondertitel={bakken ? aantal(lijst.length, 'resultaat', 'resultaten') : undefined}
        rechts={<Ververs bezig={laden} opKlik={() => void laadWerk()} />}
      />

      {tabs.length > 1 && (
        <div className="schuif-balk">
          <div className="schuif" role="tablist">
            {tabs.map((b) => (
              <button key={b} role="tab" aria-selected={bak === b} className={bak === b ? 'aan' : ''}
                onClick={() => { setBak(b); setVerkoopFilter(false) }}>
                {NAAM[b]}
                {b !== 'mij' && bakken && <span className="teller">{bakken[b].length}</span>}
              </button>
            ))}
          </div>
          {verkoopFilter && (
            <button className="link midden-link" onClick={() => setVerkoopFilter(false)}>
              Alleen verkoop · alles tonen
            </button>
          )}
        </div>
      )}

      {fout && <FoutVak tekst={fout} opnieuw={() => void laadWerk()} />}
      {!werk && laden && <Laden />}
      {bakken && lijst.length === 0 && <Leeg>{LEEG[bak]}</Leeg>}

      <ul className="lijst">
        {lijst.map((b) => <FactuurRij key={b.id} bon={b} lijst={lijst} />)}
      </ul>
    </div>
  )
}
